import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { CommonModule } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { TooltipDirective } from 'shared/directives/tooltip.directive';
import { DistributionStatusBarTypeEnum } from 'shared/enums/distribution-status-bar-type.enum';
import {
    ImageTrackerListingError,
    ImageTrackerListingWarning,
    ImageTrackerStatusType,
} from 'visuals/interfaces/visuals-image-tracker.interface';
import { ImageTrackerStatusTooltipComponent } from '../image-tracker-status-tooltip/image-tracker-status-tooltip.component';
import { ICellRendererParams } from '@ag-grid-community/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-image-tracker-listing-status-renderer',
    imports: [CommonModule, TooltipDirective, TranslatePipe],
    templateUrl: './image-tracker-listing-status-renderer.component.html',
    styleUrl: './image-tracker-listing-status-renderer.component.scss',
})
export class ImageTrackerListingStatusRendererComponent implements ICellRendererAngularComp {
    protected readonly DistributionStatusBarTypeEnum = DistributionStatusBarTypeEnum;
    protected readonly ImageTrackerStatusType = ImageTrackerStatusType;
    protected readonly listingStatusTooltip = ImageTrackerStatusTooltipComponent;

    readonly shouldShowAssetCounts = signal<boolean>(false);

    readonly displayPercentage = signal<number>(0);
    readonly listingErrors = signal<ImageTrackerListingError[]>([]);
    readonly listingWarnings = signal<ImageTrackerListingWarning[]>([]);
    readonly exportedCount = signal<number>(0);
    readonly eligibleCount = signal<number>(0);

    readonly statusDisplayType = computed(() => {
        if (this.listingErrors() && this.listingErrors().length) {
            return DistributionStatusBarTypeEnum.ICON;
        }
        return DistributionStatusBarTypeEnum.BAR;
    });

    readonly imageTrackerWarningType = computed<ImageTrackerStatusType>(() => {
        if (this.listingErrors() && this.listingErrors().length) {
            return ImageTrackerStatusType.FAILED;
        }
        if (this.listingWarnings() && this.listingWarnings().length) {
            return ImageTrackerStatusType.EXPORTED_WITH_WARNINGS;
        }
        return ImageTrackerStatusType.SUCCESSFUL;
    });

    readonly listingStatusIconTooltipData = computed(() => {
        return {
            errors: this.listingErrors(),
            warnings: this.listingWarnings(),
        };
    });

    agInit(params: ICellRendererParams): void {
        this.displayPercentage.set(params.data.percentage);
        this.listingErrors.set(params.data.errors ?? []);
        this.listingWarnings.set(params.data.warnings ?? []);
        this.exportedCount.set(params.data.exportedImagesCount);
        this.eligibleCount.set(params.data.eligibleImagesCount);
        this.shouldShowAssetCounts.set(!params.data.isPinnedRow);
    }

    refresh(params: ICellRendererParams): boolean {
        return false;
    }
}
